module.exports = __webpack_public_path__ + "img/home_btn.2a21d887.png";